<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="d-flex justify-content-between">
        <div class="section-title">
          {{ $t("Distributor Share Report New") }}
        </div>
        <div class="d-flex align-items-center">
          
          <div class="d-flex align-item-center">
                <input value="1" type="radio" v-model="lang_id">
                <span class="ml-1">English</span>
              </div>
              <div class="d-flex align-item-center ml-2">
              <input value="2" type="radio" v-model="lang_id">

              <span class="ml-1">العربية</span>
            </div>
        </div>
      </div>
      <small><em>{{ $t("* As Per Show Date") }}</em></small>

      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 col-xl-3  mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.selectedCinema && dropDown.selectedCinema
                    ? 'shift-up'
                    : 'font-weight-bold'
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder=""
                @input="onSelectCinema($event)"
                :allowEmpty="true"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <!-- <div class="col-12 col-md-6 col-lg-2 col-xl-2  mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  selectedScreen && selectedScreen.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("All") }} {{ $t("screens") }}</label
              >
              <multiselect
                :options="screenList"
                v-model="selectedScreen"
                placeholder=""
                label="screen_name"
                :multiple="true"
                :close-on-select="false"
                track-by="screen_id"
                :showLabels="false"
              ></multiselect>
            </div>
          </div> -->
          <div class="col-12 col-md-6 col-lg-2 col-xl-2  mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                   @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-2 col-xl-2  mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                              ✖
                            </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'to')"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- Distributor filter -->
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selectedDistributor.length > 0
                      ? 'shift-up'
                      : 'font-weight-bold'
                  "
                >
                  {{
                    selectedDistributor && selectedDistributor.length > 0
                      ? $t("Distributors")
                      : $t("All Distributors")
                  }}
                </label>
                <multiselect
                  v-model="selectedDistributor"
                  placeholder=""
                  :options="getDistributorReportDropdownList"
                  label="d_company_name"
                  track-by="d_id"
                  :multiple="true"
                  :close-on-select="false"
                  :searchable="true"
                  :show-labels="false"
                  name="d_id"
                  id="d_id"
                  select-label="Select"
                  deselect-label="Remove"
                  @input="onSelectHandler($event, 'distributor')"
                  @remove="onRemoveHandler($event, 'distributor')"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <!-- Distributor filter -->

          <!-- Movie filter -->
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    selectedMovie.length > 0
                      ? 'shift-up'
                      : 'font-weight-bold'
                  "
                >
                  {{
                    selectedMovie && selectedMovie.length > 0
                      ? $tc("movie", 2)
                      : $t("All") + " " + $tc("movie", 2)
                  }}
                </label>
                <multiselect
                  v-model="selectedMovie"
                  placeholder=""
                  :options="MovieList"
                  label="movie_title"
                  track-by="movie_id"
                  :multiple="true"
                  :close-on-select="false"
                  :searchable="true"
                  :show-labels="false"
                  name="movie_id"
                  id="movie_id"
                  select-label="Select"
                  deselect-label="Remove"
                  @select="onSelectHandler($event, 'movie')"
                  @remove="onRemoveHandler($event, 'movie')"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <!-- Movie filter -->

          <div class="col-12 col-md-6 col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click="onSubmit">
              {{ $t("fetch") }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="screenData.length > 0"
        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
      >
        <div class="mx-1">{{ $t("download") }} {{ $t("as") }}</div>
      
        <img
            @click="getCinemaOverallTaxAnalysisReport('Y','N')"
                class="cursor-pointer"
                height="25"
                src="@/assets/img/icons/pdf-icon.svg"
                width="25"
              />

              <img  @click="getCinemaOverallTaxAnalysisReport('N','Y')" class="cursor-pointer ml-1"
              height="25" src="@/assets/img/icons/excel.svg" width="25" />
      </div>

        <div
         class="swc-report"
        >
          <table
            class="swc-report-table swc_table_header"
            :class="lang_id==2?'swc-report-table reverse-order ':'swc-report-table order '"  
            border="1"
          >
            <thead class="bg-lightgrey">
              <tr>
                <th>{{ trans("distributionname",lang_id) }}</th>
                <th>{{ trans("screen",lang_id) }}</th>
                <th>{{ trans("showdate",lang_id)  }}</th>
                <th>{{ trans("ticketscount",lang_id) }}</th>
                <th>{{ trans("ticketscosttotal",lang_id) }}</th>
                <th>{{ trans("ticketscostforentry",lang_id) }}</th>
                <th>{{ trans("amusementtax",lang_id) }}</th>
                <th colspan="6">{{ trans("Additionalfees",lang_id) }}</th>
                <th>{{ trans("totaltax",lang_id) }}</th>
                  <th>{{ trans("vat", lang_id) }}</th>
                  <th>{{ trans("netaftervat", lang_id) }}</th>
                  <th>{{ trans("distirbutor_share_value", lang_id) }}</th>
              </tr>
              <tr>
                <th colspan="7"></th>
                <th>{{ trans("socialsubside",lang_id) }}</th>
             <th>{{ trans("cinemasubside",lang_id) }}</th>
             <th>{{ trans("policesubside",lang_id) }}</th>
             <th>{{ trans("daransubside",lang_id) }}</th>
             <th>{{ trans("servicessubside",lang_id) }}</th>
             <th>{{ trans("sports",lang_id) }}</th>
<th colspan="1"></th>
             <th colspan="1"></th>
                <th colspan="1"></th>
                  <th colspan="1"></th>
              </tr>
            </thead>
            <tbody v-if="screenData.length">
              <template v-for="screen in screenData">
                <!-- <tr class="bg-lightgrey">
                  <td class="text-left" colspan="13">{{ screen.screen_name }}</td>
                </tr> -->
                <template v-for="showDate in screen.screenData">

                <tr v-for="show in showDate.showDateData">
                   <td class="text-left">{{ show.distributor_name }}</td>
                  <td class="text-left">{{ screen.screen_name }}</td>
                  <td class="text-left">{{ moment(show.ss_start_date).format("YYYY-MM-DD") }}</td>
                  <td class="text-right">{{ show.tickets_no ||0}}</td>
                  <td class="text-right">
                    {{ parseFloat(show.tickets_gross ||0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.tickets_net || 0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.entertainment_tax ||0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.social||0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.cinema||0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.police||0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.daran||0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.services||0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.fixed_fees.sports || 0).toFixed(2) }}
                  </td>
                  <td class="text-right">
                    {{ parseFloat(show.total_tax ||0).toFixed(2) }}
                  </td>
                   <td class="text-right">
                                        {{ parseFloat(show.total_vat ||0).toFixed(2) || 0.0 }}
                                      </td>
                                      <td class="text-right">
                                        {{ parseFloat(show.total_after_vat ||0).toFixed(2) || 0.0 }}
                                      </td>
                                         <td class="text-right">
                                        {{ (parseFloat(show.total_after_vat || 0) / 2).toFixed(2) }}
                                      </td>
                </tr>
              </template>
        
              </template>
              <tr class="bg-lightgrey text-right">
                <td colspan="3" :class="lang_id==1?'text-left':'text-right'">{{ trans("grandtotal",lang_id) }}</td>
                <td>{{ grandTotal.total_tickets_no ||0 }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.total_tickets_gross ||0).toFixed(2) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.total_tickets_net ||0).toFixed(2) }}</td>
                <td class="text-right">
                  {{ parseFloat(grandTotal.total_entertainment_tax ||0).toFixed(2) }}
                </td>
                <td class="text-right">{{ parseFloat(grandTotal.social || 0 ).toFixed(2) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.cinema || 0 ).toFixed(2) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.police || 0 ).toFixed(2) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.daran || 0 ).toFixed(2) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.services || 0 ).toFixed(2) }}</td>
                <td class="text-right">{{ parseFloat(grandTotal.sports ||0).toFixed(2) }}</td>

                <td class="text-right">{{ parseFloat(grandTotal.total_tax || 0 ).toFixed(2) }}</td>
                <td class="text-right">{{ grandTotal.total_vat ? parseFloat(grandTotal.total_vat).toFixed(2) : "0.00" }}</td>
                
                              <td class="text-right">{{ grandTotal.total_after_vat ? parseFloat(grandTotal.total_after_vat).toFixed(2) : "0.00" }}</td>
                           <td class="text-right">
  {{ grandTotal.total_after_vat
      ? (parseFloat(grandTotal.total_after_vat) / 2).toFixed(2)
      : "0.00"
  }}
</td>
              </tr>
            </tbody>
            <tbody v-else>
              <td colspan="12">No Records</td>
            </tbody>
          </table>
        </div>
    </div>
  </div>
</template>
      
      <script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import NewReportService from "../../../services/NewReportService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";
import { mapGetters, mapActions } from "vuex";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { authenticationService } from "@/services/AuthenticationService";



export default {
  components: {
    NoRecords,
    VueTimepicker,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      start_time:"",
      end_time:"",
      selectedDistributor: [],
      MovieList: [],
      selectedMovie: [],
      movie_id: null,
      isReport: "Y",
      htmlToPdfOptions: {
        filename: this.pdfFileName,
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a2",
          orientation: "landscape",
        },
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCineAddress:"",
      },
      fromDate: new Date(),
      toDate: new Date(),
      advancedSalesrecords: [],
      grandTotal: {},
      screenData: [],
      screenList: [],
      selectedScreen: [],
      selectedLanguage: "en",
      lang_id:"1"
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    this.fetchReportDistributorsList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["getDistributorReportDropdownList"]),
    currentSelectedLanguage() {
      return this.$store.getters.GET_SELECTED_HEADER_LANGUAGE;
    },
    distributorIds() {
      let text = ``;
      if (this.selectedDistributor.length > 0) {
        text = this.selectedDistributor.map((x) => x.d_id).join(",");
      }
      return text;
    },
    movieIds() {
      let text = ``;
      if (this.selectedMovie.length > 0) {
        text = this.selectedMovie.map((x) => x.md_id).join(",");
      }
      return text;
    },
  },
  methods: {
    moment,
    ...mapActions(["fetchReportDistributorsList"]),
      onChangeDate(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
        this.selectedMovie = [];
        this.MovieList = [];
        if (this.selectedDistributor.length > 0) {
          this.fetchDistributorMovies();
        }
      },
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCineAddress = event.cine_address;
      // console.log("Selected Cinema Name:", this.dropDown.selectedCinemaName);
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
      this.getCinemaScreens();
      this.selectedMovie = [];
      this.MovieList = [];
      if (this.selectedDistributor.length > 0) {
        this.fetchDistributorMovies();
      }
    },
    onSelectHandler(event, type) {
      if (type == "distributor") {
        this.selectedMovie = [];
        this.MovieList = [];
        if (this.selectedDistributor.length > 0) {
          this.fetchDistributorMovies();
        }
      } else if (type == "movie") {
        this.movie_id = event.md_id;
      }
    },
    onRemoveHandler(event, type) {
      if (type == "distributor") {
        this.selectedMovie = [];
        this.MovieList = [];
        if (this.selectedDistributor.length > 0) {
          this.fetchDistributorMovies();
        }
      } else if (type == "movie") {
        this.movie_id = null;
      }
    },
    fetchDistributorMovies() {
      if (!this.dropDown.selectedCinemaId) {
        this.$toasted.show("Please Select Cinema");
        return;
      }
      if (!this.distributorIds) {
        this.MovieList = [];
        this.selectedMovie = [];
        return;
      }
      this.MovieList = [];
      let payload = {
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName,
        d_id: this.distributorIds,
        d_company_name: this.selectedDistributor
          .map((x) => x.d_company_name)
          .join(","),
        country_id: authenticationService.get("BRGLOPCO"),
        filter_with_key: "ss_actual_start_date",
      };
      ReportsService.GetDistributorMovieFormat(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records) {
            this.MovieList = data.Records;
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch((error) => {
          this.$toasted.show(
            "Catch Error on fetchDistributorMovies",
            error
          );
        });
    },
    async getCinemaOverallTaxAnalysisReport(isPdf = "N",isExcel="N") {
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader;
      try {
        let screen_id = [];
        this.screenData = [];
        if (this.selectedScreen.length) {
          screen_id = this.selectedScreen.map((screen) => screen.screen_id);
        }
        loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          screen_id,
          isPdf,
          isExcel,
          lang_id:this.lang_id,
          language: this.selectedLanguage,
          start_time:this.start_time,
          end_time:this.end_time,
          cinema_address:this.dropDown.selectedCineAddress,
           screen_name: this.selectedScreen.map(x =>x.screen_name),
          isReport: this.isReport,
        };
        if (this.distributorIds) {
          payload.d_id = this.distributorIds;
        }
        if (this.movieIds) {
          payload.movie_id = this.movieIds;
        }
        let response = await NewReportService.getDistributorShareReportReportNew(
          payload
        );
        const { data } = response;
        if (data.status && data.Records.length) {
          this.screenData = data.Records;
          this.grandTotal = data.grandTotal;
          if (isPdf == "Y" && data.pdfPath) {
            window.open(data.pdfPath, "_blank");
          }
          if (isExcel == "Y" && data.excelPath) {
            window.open(data.excelPath, "_blank");
          }
        } else {
          this.$toasted.show(data.message);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (loader) {
          loader.hide();
        }
        MasterService;
      }
    },
    async getCinemaScreens(index) {
      try {
        const response = await MasterService.GetActiveList({
          tableName: "screens",
          screen_is_active: "Y",
          cinema_id: this.dropDown.selectedCinemaId,
        });
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.screenList = data.Records;
        } else {
          console.log("show error:", data.message);
        }
      } catch (error) {
        this._CatchError(error);
      }
    },
    onSubmit() {
      this.getCinemaOverallTaxAnalysisReport();
    },
    updateLanguage(lang) {
      this.selectedLanguage = lang;
      // console.log("this.selectedLanguage:", this.selectedLanguage);
    },
  },
};
</script>
      
      <style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.rtl-table {
  direction: rtl;
  text-align: right;
}
.rtl-table-scroll {
  direction: rtl;
}
.text_right{
  text-align: right;
}
.reverse-order{
  direction: rtl;
}
.order{
  direction: ltr
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributorShareReportNew.vue